function OffenderAlcoholSchedNote(aScheduleId) {
    this.__type = 'OffenderAlcoholSchedNote:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;
    this.AlcoholScheduleId = aScheduleId;
    this.IsActive = false;
    this.UserId = -1;
    this.CreatedDateUTC = new Date();
    this.UpdatedUTC = new Date();
    this.Content = '';
}
if (typeof exports !== 'undefined') {
    module.exports = OffenderAlcoholSchedNote;
}